import Select from 'react-select';
import Disclaimer from './Disclaimer';
import '../css/components/DropDown.css';

export default function DropDown(props) {
  const {id, options, placeholder, onChange, isDisabled, error, value, mensajeDisclaimer, onBlur, onFocus, height, cssValueContainer, cssValueStatus} = props;

  let span = '';
  let textoPlaceholder = placeholder;

  if (value !== '' && value !== null) {
    span = (
      <span className={isDisabled ? 'opacity-30' : ''} id='spanDropDown'>
        {textoPlaceholder}
      </span>
    );
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: height ? height : '56px',
      minHeight: height ? height : '56px',
      background: 'var(--color-200-grey)',
      borderRadius: '8px',
      border: `2px solid ${error ? 'var(--color-dark-red)' : 'var(--color-600-grey)'}`,
      opacity: isDisabled ? '.7' : '1',
      width: '100%',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
      '@media (min-width: 1024px)': {
        background: 'white',
      },
      cursor: 'pointer'
    }),
    menuList: (base) => ({
      ...base,
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      fontFamily: 'BentonSansBBVA Book',
      fontWeight: '350',
      fontSize: '15.01px',
    }),
    menu: (base) => ({
      ...base,
      'z-index': 2,
      background: '#FFFFFF',
      borderRadius: '8px',
      padding: '10px 15px',
    }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected ? 'var(--color-dark-blue-btn)' : 'var(--color-200-grey)',
      borderRadius: '8px',
      padding: '16px',
      color: state.isSelected ? '#FFFFFF' : 'var(--color-text-midnight-blue)',
      '&:hover': {
        background: 'var(--color-dark-blue-btn)',
        color: '#FFFFFF',
      },
    }),
    placeholder: (base) => ({
      ...base,
      paddingLeft: '10px',
      fontFamily: 'BentonSansBBVA Book',
      color: error ? 'var(--color-dark-red)' : 'var(--color-600-grey)',
      fontWeight: '400',
      fontSize: '15px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: error ? 'var(--color-dark-red)' : 'var(--color-dark-blue-btn)',
      svg: {
        width: '24px', // Establece el ancho del icono
        height: '24px', // Establece la altura del icono
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      background: 'transparent',
    }),
    valueContainer: (base) => ({
      ...base,
      left: '0',
      padding: '0',
      paddingTop: cssValueContainer ? cssValueContainer : '12px',
    }),
    singleValue: (base) => ({
      ...base,
      marginLeft: '0',
      left: '16px',
      top: '60%',
      color: 'var(--color-600-grey)',
      fontSize: '15.01px',
      lineHeight: '24px',
    }),
  };

  // function eventOnchange(evt) {
  //   onChange(evt, id);
  // }

  function onBlurWrapper(e) {
    if (onBlur) {
      onBlur(e);
    }
  }

  function onFocusWrapper(e) {
    if (onFocus) {
      onFocus(e);
    }
  }

  return (
    <div className='relative'>
      <Select
        className='select-style'
        options={options}
        id={id}
        styles={customStyles}
        value={value}
        placeholder={textoPlaceholder}
        onChange={(evt) => {
          onChange(evt, id);
        }}
        onFocus={(e) => {
          onFocusWrapper(e);
        }}
        onBlur={(e) => {
          onBlurWrapper(e);
        }}
        isSearchable={false}
        isDisabled={isDisabled}
      />
      {value && span}
      <div className='w-full'>
        <Disclaimer mensaje={mensajeDisclaimer && error === '' ? mensajeDisclaimer : error} error={error !== ''} />
      </div>
    </div>
  );
}
